import React from "react";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

interface TextAreaEditorType {
  value: string;
  onChange: Function;
}

const TextAreaEditor: React.FC<TextAreaEditorType> = ({ value, onChange }) => {
  return (
    <div className="text-editor-wrapper">
      <CKEditor
        editor={ClassicEditor}
        data={value}
        config={{
          licenseKey: "",
          toolbar: [
            "heading",
            "|",
            "bold",
            "italic",
            "underline",
            "|",
            "link",
            "tables",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "undo",
            "redo",
          ],
        }}
        onReady={(editor) => {
          console.log("Editor is ready!", editor);
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
      />
    </div>
  );
};

export default TextAreaEditor;
